class CouponDrawer extends DrawerElement {
  constructor() {
    super();
  }

  // 与 SearchDrawer 一致，不把抽屉节点移动到 body 下
  get shouldAppendToBody() {
    return false;
  }

  // 缓存优惠券条目，用于进场动画
  get items() {
    return (this._items = this._items || this.querySelectorAll('.coupon-drawer__item'));
  } 

  connectedCallback() {
    // 先让 DrawerElement / ModalElement 做它自己的初始化
    if (super.connectedCallback) {
      super.connectedCallback();
    }

    // 事件委托：监听 coupon-drawer 内部的复制按钮点击
    this.addEventListener('click', (event) => {
      const target = event.target.closest('.copy-button');
      if (!target) return;

      const item = target.closest('.coupon-drawer__item');
      if (!item) return;

      const heading = item.querySelector('.coupon-drawer__item-heading');
      if (!heading) return;

      const code = heading.textContent.trim();
      if (!code) return;

      this.copyToClipboard(code).then((success) => {
        if (!success) return;
 
        this.showButtonCopiedState(target);
      });
    });
  }

  async copyToClipboard(text) {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
        return true;
      }

      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);

      return true;
    } catch (error) {
      console.error('Failed to copy coupon code', error);
      return false;
    }
  }

  /**
   * 按钮反馈：保存原文案，显示「COPIED」，2 秒后恢复
   */
  showButtonCopiedState(button) {
    const textSpan = button.querySelector('.btn-text');
    if (!textSpan) return;

    // 只在首次复制时保存原文案
    if (!button.dataset.originalLabel) {
      button.dataset.originalLabel = textSpan.textContent.trim();
    }

    // 设置“已复制”状态
    textSpan.textContent = 'COPIED';
    button.classList.add('is-copied');

    const reset = () => {
      textSpan.textContent = button.dataset.originalLabel || 'COPY';
      button.classList.remove('is-copied');
    };

    clearTimeout(this._buttonResetTimeout);
    this._buttonResetTimeout = setTimeout(reset, 800);
  }

  // 打开前动画：对每个 coupon item 做进场动画
  beforeShow() {
    super.beforeShow();

    if (!this.items.length || typeof Motion === 'undefined') return;

    setTimeout(() => {
      Motion
        .animate(
          this.items,
          {
            transform: ['translateY(1rem)', 'translateY(0)'],
            opacity: [0, 1]
          },
          {
            duration: 0.5,
            easing: [.075, .82, .165, 1],
            delay: Motion.stagger(0.08)
          }
        )
        .finished
        .then(() => {
          this.items.forEach((item) => item.removeAttribute('style'));
        });
    }, 300);
  }
}

customElements.define('coupon-drawer', CouponDrawer);